export default __webpack_public_path__ + "static/media/books.f5dfa6b9.png";